import { createFileRoute } from '@tanstack/react-router';

import { InvoicesPage } from '@/features/operator/invoices-page';
import { validateSelectionSearch } from '@/features/operator/list-search';

export const Route = createFileRoute('/_operator/invoices')({
	validateSearch: validateSelectionSearch,
	component: InvoicesPage,
});
